

import React from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Config from "../../config.js";
import MDBox from "components/MDBox";
import { Card, Grid,  Tooltip, Icon, CircularProgress, IconButton, Radio } from "@mui/material";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { PRODUCT, PRIVILEGE } from 'constants.js';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { handleErrors, checkPrivilege } from "common.js";
import ImageUrlPopup from "./ImageUrlPopup.js";
import ImagePopup from "./ImagePopup.js";

const MediaUpload = (props) => {

    const { mediaList, mediaLoading, setMediaLoading, setVariantMediaLoading, urlPopup, imageFrom, variantId,
        selectedRow, product_Id, vendorId, setUrlPopup, setMediaList, setSelectedRow, register,
        watch, control, setValue, getValues, setError, trigger, errors, setIsLoading, imagePopup,
        mediaImages, startIndex, setImagePopup, setStartIndex, addPage } = props;


    const { t } = useTranslation();
    const navigate = useNavigate();
    const adminType = localStorage.getItem("type");
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');

    const handleProductMediaUpload = (fileObjs) => {
        const fileData = { id: product_Id, vendorId: vendorId, dataFrom: imageFrom, variantId: variantId, mediaSource: 'file', imageData: fileObjs[0].data, name: fileObjs[0].file.name };
        if (imageFrom == 'product' || imageFrom == 'service')
            setMediaLoading(true);
        else
            setVariantMediaLoading(true);
        axios.post(BASE + 'api/product/addMedia', fileData, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        }).then((response) => {
            if (imageFrom == 'product' || imageFrom == 'service')
                setMediaLoading(false);
            else
                setVariantMediaLoading(false);
            if (response.status == 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                    let mList = [...mediaList];
                    const lastInsertedPosition = mList.reduce((maxPosition, item) => {
                        return Math.max(maxPosition, item.position);
                    }, 0);
                    let mediaData = { mediaURL: response.data.data.mediaURL, position: addPage ? (lastInsertedPosition + 1) : response.data.data.position, mediaType: response.data.data.mediaType, id: response.data.data.azureImageId }
                    mList.push(mediaData);
                    if (imageFrom == 'product' || imageFrom == 'service')
                        setMediaList(mList);
                    else {
                        selectedRow.imageInfo = mediaData
                        selectedRow.image = response.data.data.mediaURL;
                    }
                }
                else {
                    if (message != '')
                        toast.error(t(message))
                    if (response && response.data && response.data.errors) {
                        const errorData = response.data.errors;
                        errorData.forEach((error) => {
                            setError(error.field, {
                                type: 'server',
                                message: t(error.errors[0])
                            });
                        });
                    }
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
            }
        }).catch(error => {
            if (imageFrom == 'product' || imageFrom == 'service')
                setMediaLoading(false);
            else
                setVariantMediaLoading(false);
            handleErrors(error, t, navigate);
        });
    };

    const handleProductMediaDelete = (e, index, variant = '') => {
        let mList = [...mediaList];
        let fileData = {};
        if (index != -1)
            fileData = { productId: product_Id, vendorId: getValues('vendorId'), dataFrom: imageFrom, variantId: variant, id: mList[index].id, position: mList[index].position, mediaURL: mList[index].mediaURL };
        else
            fileData = { productId: product_Id, vendorId: getValues('vendorId'), dataFrom: imageFrom, variantId: variant, id: selectedRow.imageInfo.id, position: selectedRow.imageInfo.position, mediaURL: selectedRow.imageInfo.mediaURL };
        if (imageFrom == 'product' || imageFrom == 'service')
            setMediaLoading(true);
        else
            setVariantMediaLoading(true);
        axios.post(BASE + 'api/product/deleteProductMedia', fileData, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        }).then((response) => {
            if (imageFrom == 'product' || imageFrom == 'service')
                setMediaLoading(false);
            else
                setVariantMediaLoading(false);
            if (response.status == 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                    if (index != -1) {
                        mList.splice(index, 1);
                        setMediaList(mList);
                    }
                    else {
                        selectedRow.imageInfo = '';
                        selectedRow.image = '';
                        setSelectedRow(selectedRow);
                    }
                    toast.success(t(message))
                }
                else {
                    if (message != '')
                        toast.error(t(message))
                    if (response && response.data && response.data.errors) {
                        const errorData = response.data.errors;
                        errorData.forEach((error) => {
                            setError(error.field, {
                                type: 'server',
                                message: t(error.errors[0])
                            });
                        });
                    }
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
            }
        }).catch(error => {
            if (imageFrom == 'product' || imageFrom == 'service')
                setMediaLoading(false);
            else
                setVariantMediaLoading(false);
            handleErrors(error, t, navigate);
        });
    }

    const handleMediaUrlOpen = () => {
        setUrlPopup(true);
    }

    const handleImagePopupOpen = (index) => {
        setStartIndex(index);
        setImagePopup(true)
    }

    const moveImageToFirst = (index) => {
        if (index === 0) return;

        const updatedMediaList = [...mediaList];
        const movedImage = updatedMediaList.splice(index, 1)[0];
        updatedMediaList.unshift(movedImage);
        updatedMediaList.forEach((media, index) => {
            media.position = index + 1;
        });
        setMediaList(updatedMediaList);
    };

    return (
        <Grid container spacing={2} alignItems="center">
            {mediaList.length > 0 ?
                mediaList.map((media, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={"media" + index} className="thumbNailStyle">
                        <Card className="PositionRelative" >
                            {
                                (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("product", "write") || checkPrivilege("service", "write")))) ?
                                    <IconButton
                                        size="small"
                                        disableRipple
                                        variant="contained"
                                        className="imageIconButton"
                                        onClick={(e) => { handleProductMediaDelete(e, index) }}
                                    >
                                        <Icon className="closeIcon">close</Icon>
                                    </IconButton>
                                    : null
                            }
                            <Tooltip title={t('setdefault')}><Radio checked={index === 0} onChange={() => moveImageToFirst(index)} className="imagePositionChange" /></Tooltip>
                            <MDBox
                                component="img"
                                src={media.mediaURL}
                                onClick={(e) => handleImagePopupOpen(index)}
                                shadow="md"
                                width="100%"
                                height="50%"
                                position="relative"
                                zIndex={1}
                            />
                            <ImagePopup
                                imagePopup={imagePopup}
                                setImagePopup={setImagePopup}
                                mediaImages={mediaImages}
                                startIndex={startIndex}
                            />
                        </Card>
                    </Grid>
                ))
                :
                null
            }
            {
                (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("product", "write") || checkPrivilege("service", "write")))) ?
                    <Grid item xs={12} sm={6} md={4} lg={3} className="dropzoneAreaBaseGrid">
                        {mediaLoading ? (
                            <MDBox className="circularProgressStyle">
                                <CircularProgress color='success' size={40} className="mediaLoadingProgress" />
                            </MDBox>
                        ) : null
                        }
                        <Tooltip title={t('addFiletypes')} arrow  >
                            <Card className="dropzoneupload " >
                                <DropzoneAreaBase
                                    acceptedFiles={PRODUCT.FILETYPES}
                                    filesLimit={9999}
                                    dropzoneText={t('add')}
                                    onAdd={handleProductMediaUpload}
                                    dropzoneClass={"dropzonestyle"}
                                    Icon={''}
                                    maxFileSize={20 * 1024 * 1024}
                                />
                                <MDButton variant="outlined" color="info" disableRipple className="addUrlButton" onClick={handleMediaUrlOpen} >{t('addFromUrl')}</MDButton>
                            </Card>
                        </Tooltip>
                        {urlPopup ?
                            <ImageUrlPopup
                                imageFrom={imageFrom}
                                urlPopup={urlPopup}
                                selectedRow={selectedRow}
                                productId={product_Id}
                                vendorId={vendorId}
                                setUrlPopup={setUrlPopup}
                                mediaList={mediaList}
                                setMediaList={setMediaList}
                                setSelectedRow={setSelectedRow}
                                register={register}
                                watch={watch}
                                control={control}
                                setValue={setValue}
                                getValues={getValues}
                                setError={setError}
                                trigger={trigger}
                                errors={errors}
                                setIsLoading={setIsLoading}
                            /> :
                            null
                        }
                    </Grid>
                    : null
            }
        </Grid>
    )


}
export default MediaUpload;
